import React, { SVGProps } from 'react';

export const CalendarPlus = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="48"
      height="48"
      viewBox="0 0 24 25"
      {...props}
    >
      <path
        opacity="0.4"
        d="M20 8.5V12.9609C20 13.1669 19.802 13.301 19.605 13.24C19.02 13.058 18.396 12.9781 17.739 13.0071C14.954 13.1301 12.6279 15.456 12.5049 18.241C12.4759 18.898 12.556 19.5219 12.738 20.1069C12.799 20.3029 12.665 20.502 12.459 20.502H5C3 20.502 2 19.502 2 17.502V8.50195H20V8.5Z"
        fill="#feb96f"
      ></path>
      <path
        d="M17 4H15.75V2.5C15.75 2.086 15.414 1.75 15 1.75C14.586 1.75 14.25 2.086 14.25 2.5V4H7.75V2.5C7.75 2.086 7.414 1.75 7 1.75C6.586 1.75 6.25 2.086 6.25 2.5V4H5C3 4 2 5 2 7V8.5H20V7C20 5 19 4 17 4Z"
        fill="#ffffff"
      ></path>
      <path
        d="M7.01978 13.5C6.46778 13.5 6.01465 13.052 6.01465 12.5C6.01465 11.948 6.45777 11.5 7.00977 11.5H7.01978C7.57278 11.5 8.01978 11.948 8.01978 12.5C8.01978 13.052 7.57178 13.5 7.01978 13.5ZM12.0017 12.5C12.0017 11.948 11.5547 11.5 11.0017 11.5H10.9917C10.4397 11.5 9.99683 11.948 9.99683 12.5C9.99683 13.052 10.4497 13.5 11.0017 13.5C11.5547 13.5 12.0017 13.052 12.0017 12.5ZM8.01978 16.5C8.01978 15.948 7.57278 15.5 7.01978 15.5H7.00977C6.45777 15.5 6.01465 15.948 6.01465 16.5C6.01465 17.052 6.46778 17.5 7.01978 17.5C7.57178 17.5 8.01978 17.052 8.01978 16.5Z"
        fill="#ffffff"
      ></path>
      <path
        d="M18 14.5C15.791 14.5 14 16.291 14 18.5C14 20.709 15.791 22.5 18 22.5C20.209 22.5 22 20.709 22 18.5C22 16.291 20.209 14.5 18 14.5ZM19.25 19H18.5V19.75C18.5 20.026 18.276 20.25 18 20.25C17.724 20.25 17.5 20.026 17.5 19.75V19H16.75C16.474 19 16.25 18.776 16.25 18.5C16.25 18.224 16.474 18 16.75 18H17.5V17.25C17.5 16.974 17.724 16.75 18 16.75C18.276 16.75 18.5 16.974 18.5 17.25V18H19.25C19.526 18 19.75 18.224 19.75 18.5C19.75 18.776 19.526 19 19.25 19Z"
        fill="#ffb870"
      ></path>
    </svg>
  );
};
